export default "__VITE_ASSET__C5IYXQ8Q__"